export enum YmGoalLocationCityGuess {
  LocationCityGuessConfirmed = 'locationCityGuessConfirmed',
  LocationCityGuessDenied = 'locationCityGuessDenied',
}
